var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"global-block-overlay",attrs:{"role":"presentation","aria-hidden":"true"}},[_c('div',{staticClass:"overlay-box"},[_c('i',{staticClass:"el-icon-loading overlay-spinner",attrs:{"aria-hidden":"true"}}),_c('div',{staticClass:"overlay-text"},[_vm._v(_vm._s(_vm.loadText))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }